import 'whatwg-fetch'
import {
  API_URL
} from '../constants/configValues'

const headerJson = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
}
const system = {
  fetchSystem() {
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/list`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({
            status: response.status,
            statusText: response.statusText
          })
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}
export default system



// WEBPACK FOOTER //
// ./src/api/system.js